import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { tr } from '../i18n/tr';

export interface Crumb {
  label: string;
  to?: string;
}
export interface PageMeta {
  title: string;
  crumbs: Crumb[];
}

const SetMetaContext = createContext<((m: PageMeta) => void) | null>(null);
const MetaContext = createContext<PageMeta | null>(null);

/** Kabuğun üst çubuğu için sayfa bağlamı (başlık + konum) ve belge başlığı. */
export function PageMetaProvider({ children }: { children: ReactNode }) {
  const [meta, setMeta] = useState<PageMeta | null>(null);
  return (
    <SetMetaContext.Provider value={setMeta}>
      <MetaContext.Provider value={meta}>{children}</MetaContext.Provider>
    </SetMetaContext.Provider>
  );
}

export function useCurrentPageMeta(): PageMeta | null {
  return useContext(MetaContext);
}

/**
 * Sayfa başlığı: `document.title` rota değişiminde güncellenir (ekran okuyucu ve sekme adı); kabuk içindeyse üst
 * çubuktaki konum da bu değerden gelir. Kabuk dışında (giriş/kayıt) yalnız belge başlığı yazılır.
 */
export function usePageMeta(title: string, crumbs: Crumb[] = []) {
  const set = useContext(SetMetaContext);
  const key = JSON.stringify(crumbs);
  useEffect(() => {
    document.title = tr.pageTitle(title);
    set?.({ title, crumbs: JSON.parse(key) as Crumb[] });
  }, [title, key, set]);
}
